<template>
    <BaseDialog
        :model-value="modelValue"
        :title="title"
        max-width="400px"
        @update:model-value="$emit('update:modelValue', $event)"
    >
        {{ message }}
        <template #actions>
            <v-spacer />
            <v-btn
                color="primary"
                @click="$emit('update:modelValue', false)"
            >
                {{ closeButtonText }}
            </v-btn>
        </template>
    </BaseDialog>
</template>

<script lang="ts" setup>
import BaseDialog from '@/shared/components/dialogs/_BaseDialog.vue';

interface Props {
    modelValue: boolean;
    title: string;
    message: string;
    closeButtonText?: string;
}

withDefaults(defineProps<Props>(), {
    closeButtonText: 'Close',
});

defineEmits<{
    (event: 'update:modelValue', value: boolean): void;
}>();
</script>
